import React from "react"
import PropTypes from "prop-types"

const AccountIcon = ({ style }) => (
  <svg style={style} viewBox="0 0 13 14">
    <path d="M4.21585541,3.53866667 C4.21585541,5.24933333 5.19305812,6.53866667 6.5,6.53866667 C7.8056069,6.53866667 8.78414459,5.24933333 8.78414459,3.53866667 C8.78414459,2.304 7.71215855,1.21066667 6.5,1.21066667 C5.28784145,1.21066667 4.21585541,2.304 4.21585541,3.53866667 Z M2.995687,3.53866667 C2.995687,1.624 4.59899363,0 6.5,0 C8.40100637,0 10.004313,1.624 10.004313,3.53866667 C10.004313,5.93733333 8.49445471,7.74933333 6.5,7.74933333 C4.50554529,7.74933333 2.995687,5.93733333 2.995687,3.53866667 Z M0,14 L0.109468063,12.7186667 C0.383138221,10.156 2.63524338,8.74933333 6.5,8.74933333 C10.3634216,8.74933333 12.6168618,10.156 12.8905319,12.7106667 L13,14 L11.7491271,14 L11.6396591,12.828 C11.3966934,10.492 8.7214007,9.976 6.5,9.976 C4.2785993,9.976 1.60330663,10.492 1.36034093,12.836 L1.25087287,14 L0,14 Z"></path>
  </svg>
)

AccountIcon.propTypes = {
  style: PropTypes.object
}

export default AccountIcon



// WEBPACK FOOTER //
// ./src/components/icons/account-icon.jsx